import { Auth } from "aws-amplify";

export function anonymize(value) {
    let demo = false;
    try {
        demo = localStorage.getItem('isDemoUser') === "true" || localStorage.getItem('isDemoUser') === true;
    } catch (e) {}
    return demo ? " " : value;
}

export function reverse_if_demo(value) {
    let demo = false;
    try {
        demo = localStorage.getItem('isDemoUser') === "true" || localStorage.getItem('isDemoUser') === true;
    } catch (e) {}
    return demo ? !value : value;
}

export function empty_list_if_demo(value) {
    let demo = false;
    try {
        demo = localStorage.getItem('isDemoUser') === "true" || localStorage.getItem('isDemoUser') === true;
    } catch (e) {}
    return demo ? [] : value;
}

export async function setDemoFlag() {
    const data = await Auth.currentAuthenticatedUser().then((data) => data);
    const isDemo = data?.username && data?.username.includes("demo.user");
    try {
        localStorage.setItem('isDemoUser', isDemo ? true : false);
    } catch (e) {}
    return isDemo;
}
